import { faAdd } from '@fortawesome/pro-light-svg-icons'
import { useCallback, useMemo, useRef, useState } from 'react'
import ModalCreateCustomer from '../../../../../app/erp/screens/Company/CustomerParent/AllCustomers/ModalCreateCustomer'
import ModalCreateBuyOrder from '../../../../../app/erp/screens/Logistic/BuyParent/BuyOrders/ModalCreateBuyOrder'
import ModalCreateProductConnect from '../../../../../app/erp/screens/Logistic/ProductsParent/Products/ModalCreateProduct'
import ModalCreateServiceConnect from '../../../../../app/erp/screens/Logistic/ProductsParent/Services/ModalCreateService'
import ModalCreateQuoteOrder from '../../../../../app/erp/screens/Logistic/QuoteParent/QuoteOrders/ModalCreateQuoteOrder'
import ModalCreateSellInvoice from '../../../../../app/erp/screens/Logistic/QuoteParent/SellParent/SellInvoices/ModalCreateSellInvoice'
import ModalCreateSellOrder from '../../../../../app/erp/screens/Logistic/QuoteParent/SellParent/SellOrders/ModalCreateSellOrder'
import ModalCreateTaskWithHelper from '../../../../../specificComponents/Task/ModalCreateTaskWithHelper'
import { haveModuleBuyed } from '../../../../../utils/globals'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import useOnClickOutside from '../../../../../utils/hooks/useOnClickOut'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { getEmployeeParams, getModulesBuyed, getUserPermissions } from '../../../../../utils/reducers/getters'
import { ModalOpenedTy } from '../../../../Modal/types'
import { permissionCheck } from '../../../../PermissionChecker/function'
import { VerticalSortItem } from '../../../../Sorts/VerticalSortList/types'
import TwinIcon from '../../../../TwinIcon'
import ModalQuickCreateToolsConfig from './ModalQuickCreateToolsConfig'
import { RightHeaderCreateToolItemProps, RightHeaderCreateToolItemsTy } from './types'
import ModalCreateCustomerProject from '../../../../../app/erp/screens/Company/CustomerParent/CustomerProjects/ModalCreateCustomerProject'
import ModalEditCustomerProject from '../../../../../specificComponents/Customers/ModalEditCustomerProject'
import { useCustomerParsedLinkGet } from '../../../../../utils/hooks/customer/useCustomerTypesDict'
import { useNavigate } from 'react-router'
import locations from '../../../../../utils/globals/locations'

interface QuickCreateUserToolsProps { }

const QuickCreateTools: React.FC<QuickCreateUserToolsProps> = () => {
    const { ref, opened, setOpened, setLockOnClickOut, openModal, setOpenModal, myOnClick } = useQuickCreateToolsLogic()
    return (
        <div className='flex items-center justify-center cursor-pointer quick_create_tools_menu relative' ref={ref}>
            <TwinIcon icon={faAdd} className='quick_create_tools_icon' onClick={myOnClick} />
            <div className={'quick_create_tools_main_container absolute z-9 ' + (opened ? 'active' : '')}>
                <QuickCreateToolsMenu  openModal={openModal} setOpenModal={setOpenModal} setOpened={setOpened} setLockOnClickOut={setLockOnClickOut} /> 
            </div>
        </div>
    )
}

const useQuickCreateToolsLogic = () => {
    const [opened, setOpened] = useState(false)
    const [openModal, setOpenModal] = useState<TwinDictionary | null>(null)
    const [LockOnClickOut, setLockOnClickOut] = useState(false)
    const ref = useRef<any>(null)
    const myActiveCreateToolsParameter = getEmployeeParams()?.['quickCreateTools']
    const myActiveQuickCreateTools = useMemo(() => myActiveCreateToolsParameter ? JSON.parse(myActiveCreateToolsParameter || '') : null, [myActiveCreateToolsParameter])

    const myOnClick = useCallback(() => {
        if (myActiveQuickCreateTools && myActiveQuickCreateTools.length === 1) {
            setOpenModal({ type: myActiveQuickCreateTools[0]?.id, allRowData: {} })
            setOpened(true)
        } else {
            setOpened((old) => !old)
        }
    }, [setOpened, myActiveQuickCreateTools])
    
    const onReset = useCallback(() => {
        setOpened(false)
    }, [setOpened])
    useOnClickOutside(ref, () => !LockOnClickOut ? onReset() : null)

    return { ref, opened, setOpened, setLockOnClickOut, setOpenModal, openModal, myOnClick }
}

interface QuickCreateToolsMenuProps {
    setOpened: React.Dispatch<React.SetStateAction<boolean>>
    setOpenModal: React.Dispatch<React.SetStateAction<TwinDictionary | null>>
    openModal: TwinDictionary | null
    setLockOnClickOut?: (lock: boolean) => void
 }

const QuickCreateToolsMenu: React.FC<QuickCreateToolsMenuProps> = ({ setOpened, setLockOnClickOut, openModal, setOpenModal }) => {
    const { myCreateToolsItems, myActiveQuickCreateTools, openSubModal, setOpenSubModal } = useQuickCreateToolsMenuLogic()
    
    const renderThis: JSX.Element[] = []
    if (myActiveQuickCreateTools) {
        for (const key in myActiveQuickCreateTools) {
            const toolItemFromParameters = myActiveQuickCreateTools[key]
            renderThis.push(
                <div className='hover:bg-green-DB px-6 py-3 rounded-sm cursor-pointer' onClick={() => {setOpenModal({ type: toolItemFromParameters?.id, allRowData: {} }); setOpened(true)}} key={key}>{toolItemFromParameters?.name}</div>
            )
        }
    }

    const componentTypes = openModal?.type || openSubModal?.type
    const myModal = componentTypes ? myCreateToolsItems[componentTypes as RightHeaderCreateToolItemsTy] : null
    const ModalComponent = myModal?.component
    const ModalSubcomponent = myModal?.subcomponent
    const myOnSubmit = myModal?.onSubmit ? myModal.onSubmit : () => { }
    
    return (
        <div className='flex flex-col bg-white p-15 rounded-8 shadow-lg mr-15 w-200 max-h-700 quick_create_tools_main'>
            <div className='flex flex-col gap-y-1'>
                {renderThis}
            </div>
            <ButtonPersonalizeQuickCreateTools myCreateToolsItems={myCreateToolsItems} myActiveCreateToolsItems={myActiveQuickCreateTools} setIsOpened={setOpened} />
            {openModal?.type && ModalComponent ? <ModalComponent setOpened={() => { openModal?.type !== 'project' && setOpened(false); setOpenModal(null) }} onSubmit={myOnSubmit} allRowData={{}} setLockOnClickOut={setLockOnClickOut} /> : null}
            {openSubModal?.type && ModalSubcomponent ? <ModalSubcomponent setOpened={() => { setOpenSubModal(null); setOpened(false) }} onSubmit={() => { }} allRowData={openSubModal?.allRowData} /> : null}
        </div>
    )
}

const useQuickCreateToolsMenuLogic = () => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()
    const [openSubModal, setOpenSubModal] = useState<TwinDictionary | null>(null)
    const myActiveCreateToolsParameter = getEmployeeParams()?.['quickCreateTools']
    const myActiveQuickCreateTools = useMemo(() => myActiveCreateToolsParameter ? JSON.parse(myActiveCreateToolsParameter || '') : null, [myActiveCreateToolsParameter])
    const { getParsedCustomerLink } = useCustomerParsedLinkGet()

    const taskText = t('task', 'Tarea')
    const customerText = t('client', 'Cliente')
    const quoteOrderText = t('quoteOrder', 'Presupuesto')
    const sellOrderText = t('singleOrder', 'Pedido')
    const buyOrderText = t('buyBuyOrder', 'Pedido de compra')
    const invoiceText = t('invoice', 'Factura')
    const productText = t('product', 'Producto')
    const serviceText = t('service', 'Servicio')
    const projectText = t('project', 'Proyecto')

    const myCreateToolsItems = useMemo(() => {
        const myModules = getModulesBuyed()
        const haveTaskBuyed = haveModuleBuyed(['tasks'], myModules)
        const haveQuotesBuyed = haveModuleBuyed(['quotes'], myModules)
        const haveProductsBuyed = haveModuleBuyed(['products'], myModules)

        const items: Record<RightHeaderCreateToolItemsTy, RightHeaderCreateToolItemProps> = {
            customer: {
                id: 'customer',
                component: ModalCreateCustomer,
                title: customerText,
                havePermission: permissionCheck(getUserPermissions('customer.profile.main'), 'create'),
                haveModuleBuyed: haveTaskBuyed,
                onSubmit: async (res) => {
                    if (res.status === 200) {
                        const val = await res.json()
                        navigate(getParsedCustomerLink(val?.id, val?.customer_type))
                    }
                }
            },
            project: {
                id: 'project',
                component: ModalCreateCustomerProject,
                subcomponent: ModalEditCustomerProject, 
                title: projectText,
                havePermission: permissionCheck(getUserPermissions('customer.projects.main'), 'create'),
                haveModuleBuyed: haveTaskBuyed,
                onSubmit: async (res) => {
                    if (res.status === 200) {
                        const val = await res.json()
                        navigate(locations.customerProjects)
                        setOpenSubModal({type: 'project', allRowData: {id: val?.id}})
                    }
                }
            },
            quoteOrder: { 
                id: 'quoteOrder',
                component: ModalCreateQuoteOrder, 
                title: quoteOrderText, 
                havePermission: permissionCheck(getUserPermissions('quote.order'), 'create'),
                haveModuleBuyed: haveQuotesBuyed
            },
            sellOrder: { 
                id: 'sellOrder',
                component: ModalCreateSellOrder, 
                title: sellOrderText,
                havePermission: permissionCheck(getUserPermissions('customer.profile.main'), 'create'),
                haveModuleBuyed: haveQuotesBuyed
            },
            invoice: {
                id: 'invoice',
                component: ModalCreateSellInvoice,
                title: invoiceText,
                havePermission: permissionCheck(getUserPermissions('customer.profile.main'), 'create'),
                haveModuleBuyed: haveQuotesBuyed
            },
            buyOrder: { 
                id: 'buyOrder',
                component: ModalCreateBuyOrder, 
                title: buyOrderText, 
                havePermission: permissionCheck(getUserPermissions('supplier.main'), 'create'),
                haveModuleBuyed: haveQuotesBuyed
            },
            product: { 
                id: 'product',
                component: ModalCreateProductConnect, 
                title: productText, 
                havePermission: permissionCheck(getUserPermissions('product.profile.main'), 'create'),
                haveModuleBuyed: haveProductsBuyed
            },
            service: {
                id: 'service',
                component: ModalCreateServiceConnect, 
                title: serviceText, 
                havePermission: permissionCheck(getUserPermissions('product.service.main'), 'create'),
                haveModuleBuyed: haveProductsBuyed
            },
            task: {
                id: 'task',
                component: ModalCreateTaskWithHelper,
                title: taskText,
                havePermission: permissionCheck(getUserPermissions('task.main'), 'create'),
                haveModuleBuyed: haveTaskBuyed
            },
        }

        const myFilteredShortcuts: TwinDictionary = {}
        for (const key in items) {
            const element = items[key as RightHeaderCreateToolItemsTy]
            if (element.havePermission && element.haveModuleBuyed) {
                myFilteredShortcuts[key] = element
            }
        }
        return myFilteredShortcuts
    }, [taskText, customerText, quoteOrderText, sellOrderText, buyOrderText, invoiceText, productText, serviceText, navigate, projectText, getParsedCustomerLink])

    return { myCreateToolsItems, myActiveQuickCreateTools, openSubModal, setOpenSubModal }
}

interface ButtonPersonalizeQuickCreateToolsProps {
    myCreateToolsItems: TwinDictionary
    myActiveCreateToolsItems: VerticalSortItem[]
    setIsOpened: React.Dispatch<React.SetStateAction<boolean>>
}

const ButtonPersonalizeQuickCreateTools: React.FC<ButtonPersonalizeQuickCreateToolsProps> = ({ myActiveCreateToolsItems, setIsOpened, ...props }) => {
    const { t } = useTwinTranslation()
    const { opened, setOpened } = useButtonPersonalizeQuickCreateToolsLogic()
    let renderThis: JSX.Element | null = null
    if (myActiveCreateToolsItems?.length) {
        renderThis = (
            <div className='mt-8 px-6'>
                <div className='border-b border-gray-EE' />
            </div>
        )
    }
    return (
        <div>
            {renderThis}
            <div className='mt-8 px-6 py-3 hover:bg-green-DB rounded-sm' onClick={() => { setOpened(true);  setIsOpened(true)}}>{t('personalize', 'Personalizar')}</div>
            {opened ? 
                <ModalQuickCreateToolsConfig myActiveCreateToolsItems={myActiveCreateToolsItems} setOpened={setOpened} {...props} />
                : null
            }
        </div>
    )
}

const useButtonPersonalizeQuickCreateToolsLogic = () => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    return {opened, setOpened}
}

export default QuickCreateTools